<i class="iconfont icon-close"></i>
<div class="magicWake-content-con">
    <div class="magicWake-title">
    {{if FreeCount}}
    免费唤醒，<span>剩余次数：{{FreeCount}}次</span>
    {{else}}
    本次魔术唤醒{{OnceMoney}}声币
    {{/if}}
    </div>
    <ul class="magicWake-content">
        {{each Data item index}}
            {{ if  index === 0}}
            <li class="magicWake-content-item clearfix active" data-id="{{item.ID}}">
                <span class="fl">{{item.Content}}</span>
                <i class="iconfont icon-weixuanzhong fr"></i>
            </li>
            {{else}}
            <li class="magicWake-content-item clearfix" data-id="{{item.ID}}">
                <span class="fl">{{item.Content}}</span>
                <i class="iconfont icon-weixuanzhong fr"></i>
            </li>
            {{ /if}}
        {{/each}}
    </ul>
    <ul class="mt20" style="font-size: 12px; color: #fff">
        <li class="mb10">1、选中的密语信息将会用过手机短信发送给对方请求语聊</li>
        <li class="mb10">2、对方回复确认可自动接通你们的电话，语聊费需由您支付</li>
        <li class="mb10">3、若30分钟内未能成功接通则返还4美币至您的账户<li>
        <li>4、免费唤醒说明：守护间每日3次，VIP每月10次，优先用VIP次数</li>
    <ul>
</div>
<div class="btn-wrap" style='padding: 40px 0; text-align:center'>
    {{if IsMobileOk}}
        <a class="btn-save w380btn gradientColor" id="toWaking">立即唤醒</a>
    {{else}}
        <a class="btn-save w380btn gradientColor" id="toBind">绑定手机-绑定手机号后可唤醒TA</a>
    {{/if}}
    
</div>